<aside [ngClass]="{ show: isVisible, 'small-device': isSmallDevice }">
  <a class="logo" [routerLink]="['']" *ngIf="!isSmallDevice">
    <span class="logo-mark">
      <!-- O escopo (Brasil / Internacional) é mostrado pela pílula do header;
           o logo não repete o indicador (pedido do Bruno, 21/09/2026). -->
      <img src="/assets/logo-smsfunnel.png" alt="SMS Funnel" title="SMS Funnel" />
    </span>
    <span class="brand-title">{{ title }}</span>
  </a>

  <!-- Busca global na barra lateral, logo abaixo da marca (Bruno, 09/10/2026; antes ficava no
       header). Itens do cliente para todos; os do Admin só para administrador. Ctrl+K continua. -->
  <div class="menu-search" data-testid="menu-search">
    <app-global-search class="in-sidebar" [compact]="!isVisible"></app-global-search>
  </div>

  <h3 *ngIf="user.simulated && !isSmallDevice">Simulando usuário</h3>

  <!-- Etiqueta "Novo" (CU-17tm466mg60), com o visual do `.badge-new` do protótipo:
       pílula depois do rótulo e antes do chevron. Na barra recolhida não há rótulo
       para ela acompanhar, então vira um pontinho no canto do ícone. -->
  <ng-template #newBadgeMark let-item>
    <ng-container *ngIf="newBadgeVisible.get(item); else fixedBadge">
      <span *ngIf="isVisible" class="menu-badge" data-testid="menu-new-badge">Novo</span>
      <span *ngIf="!isVisible" class="menu-new-dot" data-testid="menu-new-dot" role="img" aria-label="Novo"></span>
    </ng-container>
    <!-- Selo fixo (`badge` do catálogo), com o mesmo visual; não é a etiqueta configurável. -->
    <ng-template #fixedBadge>
      <span *ngIf="item.badge && isVisible" class="menu-badge" data-testid="menu-fixed-badge">{{ item.badge }}</span>
      <span *ngIf="item.badge && !isVisible" class="menu-new-dot" data-testid="menu-fixed-dot" role="img" [attr.aria-label]="item.badge"></span>
    </ng-template>
  </ng-template>

  <!-- Um único molde para os dois grupos: o rodapé não é um item diferente, é o
       mesmo item em outro lugar da barra. -->
  <ng-template #menuEntry let-item>
    <li
      *ngIf="!item.children || item.children.length === 0"
      class="menu-item"
      [attr.data-path]="item.path"
      [routerLink]="item.path"
      (click)="closeOnSmallDevice()"
      routerLinkActive="active"
    >
      <i class="fa" *ngIf="item.icon" [class]="item.icon || 'fa-file'"></i>
      <img *ngIf="item.image" [src]="item.image" [alt]="item.text" class="section_image"/>
      <span class="menu-label" *ngIf="isVisible" [attr.title]="item.text">{{ item.text }}</span>
      <ng-container *ngTemplateOutlet="newBadgeMark; context: { $implicit: item }"></ng-container>
    </li>

    <li
      *ngIf="item.children && item.children.length > 0"
      [ngClass]="{'submenu-parent': true, 'menu-open': isGroupExpanded(item)}"
    >
      <span class="menu-item" [attr.data-path]="item.path" (click)="toggleGroup(item)">
        <i class="fa" [class]="item.icon || 'fa-file'"></i>
        <span class="menu-label" *ngIf="isVisible" [attr.title]="item.text">{{ item.text }}</span>
        <ng-container *ngTemplateOutlet="newBadgeMark; context: { $implicit: item }"></ng-container>
        <i
          *ngIf="isVisible"
          class="fa chevron"
          [class.fa-chevron-down]="!isGroupExpanded(item)"
          [class.fa-chevron-up]="isGroupExpanded(item)"
        ></i>
      </span>
      <ul *ngIf="isGroupExpanded(item) && isVisible">
        <li
          *ngFor="let child of item.children"
          class="menu-item menu-subitem"
          [attr.data-path]="child.path"
          [routerLink]="child.path"
          (click)="closeOnSmallDevice()"
          routerLinkActive="active"
        >
          <i class="fa" *ngIf="child.icon" [class]="child.icon || 'fa-file'"></i>
          <span class="menu-label" [attr.title]="child.text">{{ child.text }}</span>
          <ng-container *ngTemplateOutlet="newBadgeMark; context: { $implicit: child }"></ng-container>
        </li>
        <li routerLink="/audit-logs" routerLinkActive="active" data-testid="admin-audit-logs">
          <i class="fa me-2 fa-history"></i>
          <span>Logs de Auditoria</span>
        </li>
      </ul>
    </li>
  </ng-template>

  <nav class="menu-nav">
    <ul class="menu-group" data-testid="menu-main">
      <!-- Admin no desenho "Opção A" (28/09/2026): cabeçalho com selo, busca
           e seções recolhíveis (sem Dashboard: pedido do Bruno, 28/09/2026). É o único endereço do back-office —
           o que nenhum cliente vê saiu da lista principal e mora aqui. -->
      <li [ngClass]="{'admin-menu': true, 'menu-open': adminMenuVisible}" *ngIf="isAdministrator" data-testid="admin-area">
        <span
          class="menu-item admin-header"
          (click)="toggleAdminMenu()"
          [attr.title]="isVisible ? null : 'Admin'"
          data-testid="admin-toggle"
        >
          <span class="admin-avatar" aria-hidden="true">A</span>
          <span class="menu-label admin-title" *ngIf="isVisible">Admin</span>
          <i *ngIf="isVisible" class="fa chevron" [class.fa-chevron-down]="!adminMenuVisible" [class.fa-chevron-up]="adminMenuVisible"></i>
        </span>

        <div *ngIf="adminMenuVisible" class="admin-body">
          <ul class="admin-sections">
            <!-- A cor da seção entra como `--section-color` no `li` e pinta o
                 selo quadrado do cabeçalho; os itens ficam neutros. -->
            <li
              *ngFor="let section of adminSections"
              [ngClass]="{'admin-section': true, 'menu-open': isSectionOpen(section)}"
              [style.--section-color]="sectionColor(section)"
              [attr.data-testid]="'admin-section-' + section.key"
            >
              <span
                class="menu-item menu-section-title"
                (click)="toggleSubmenu(section.key)"
                [attr.title]="isVisible ? null : section.label"
              >
                <span class="section-badge" aria-hidden="true"><i class="fa" [class]="section.icon"></i></span>
                <span class="menu-label" *ngIf="isVisible">{{ section.label }}</span>
                <i
                  *ngIf="isVisible"
                  class="fa chevron"
                  [class.fa-chevron-down]="!openSubmenus[section.key]"
                  [class.fa-chevron-up]="openSubmenus[section.key]"
                ></i>
              </span>

              <ul *ngIf="isSectionOpen(section)">
                <ng-container *ngFor="let item of section.items">
                  <!-- Destino interno: o `li` inteiro é o link, como no resto do
                       menu, para a pílula toda ser clicável. -->
                  <li
                    *ngIf="item.path"
                    class="menu-item menu-subitem"
                    [attr.data-path]="item.path"
                    [routerLink]="item.path"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: !!item.exact }"
                    [attr.data-testid]="item.testId"
                    [attr.title]="isVisible ? null : item.label"
                    (click)="closeOnSmallDevice()"
                  >
                    <i class="fa" [class]="item.icon"></i>
                    <span class="menu-label" [attr.title]="item.label">{{ item.label }}</span>
                    <!-- Selo fixo do catálogo Admin (ex.: "Novo" no Acompanhamento de agentes RCS,
                         17tm466frtx). Mesmo visual do selo do menu principal (`.menu-badge`), mas
                         sem o `ng-template` de lá: `AdminMenuItem` não é `MenuItem`, e o selo daqui
                         é sempre fixo — não há "já vi" nem `newBadgeVisible` para ele apagar. -->
                    <span *ngIf="item.badge && isVisible" class="menu-badge" data-testid="menu-admin-badge">{{ item.badge }}</span>
                    <span *ngIf="item.badge && !isVisible" class="menu-new-dot" data-testid="menu-admin-dot" role="img" [attr.aria-label]="item.badge"></span>
                  </li>

                  <!-- Destino externo: tela fora do Angular, abre em aba nova.
                       O link envolve o ícone para continuar clicável no trilho,
                       onde o rótulo some. -->
                  <li *ngIf="item.externalPath" class="menu-item menu-subitem menu-external">
                    <a
                      class="menu-link"
                      [href]="externalUrl(item.externalPath)"
                      target="_blank"
                      rel="noopener"
                      [attr.data-testid]="item.testId"
                      [attr.title]="isVisible ? null : item.label"
                    >
                      <i class="fa" [class]="item.icon"></i>
                      <span class="menu-label" [attr.title]="item.label">{{ item.label }}</span>
                      <span *ngIf="item.badge && isVisible" class="menu-badge" data-testid="menu-admin-badge">{{ item.badge }}</span>
                      <span *ngIf="item.badge && !isVisible" class="menu-new-dot" data-testid="menu-admin-dot" role="img" [attr.aria-label]="item.badge"></span>
                    </a>
                  </li>
                </ng-container>
              </ul>
            </li>

          </ul>
        </div>
      </li>

      <ng-container *ngFor="let item of menuItems">
        <ng-container
          *ngIf="!item.footer"
          [ngTemplateOutlet]="menuEntry"
          [ngTemplateOutletContext]="{ $implicit: item }"
        ></ng-container>

        <!-- "Integrações" e "Plataformas": renderizados logo abaixo de "Recarga" -->
        <li
          *ngIf="item.path === '/recharges'"
          class="menu-item"
          routerLink="/integrations"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="closeOnSmallDevice()"
          data-testid="menu-integrations"
        >
          <i class="fa fa-link"></i>
          <span class="menu-label" *ngIf="isVisible">Integrações</span>
        </li>
        <li
          *ngIf="item.path === '/recharges' && canProposeIntegrations"
          class="menu-item"
          routerLink="/integrations/platform"
          routerLinkActive="active"
          (click)="closeOnSmallDevice()"
          data-testid="menu-integration-templates"
        >
          <i class="fa fa-plug"></i>
          <span class="menu-label" *ngIf="isVisible">Plataformas</span>
          <span
            *ngIf="isAdministrator && pendingApprovalsCount > 0"
            class="menu-badge"
            data-testid="menu-platforms-pending-count"
          >{{ pendingApprovalsCount }}</span>
        </li>
      </ng-container>
    </ul>

    <!-- Grupo separado do rodapé, como no protótipo: o que não é trabalho do
         dia a dia sai da lista principal. -->
    <ul class="menu-group menu-group-footer" data-testid="menu-footer">
      <ng-container *ngFor="let item of menuItems">
        <ng-container
          *ngIf="item.footer"
          [ngTemplateOutlet]="menuEntry"
          [ngTemplateOutletContext]="{ $implicit: item }"
        ></ng-container>
      </ng-container>

      <li class="menu-item" data-testid="support-area">
        <!-- O link envolve ícone e rótulo: na barra recolhida só o ícone
             aparece, e ele precisa continuar clicável. -->
        <a
          class="menu-link"
          href="{{ supportLink }}?text=Olá, meu nome é {{
            supportName
          }} e estou com uma dúvida!"
          target="_blank"
          data-testid="support-link"
        >
          <i class="fa fa-question-circle-o"></i>
          <span class="menu-label" *ngIf="isVisible">Suporte</span>
        </a>
      </li>
    </ul>
  </nav>

</aside>

<!-- Gaveta do celular: o clique fora fecha. Quem abre é o hambúrguer do header. -->
<div
  class="overlay"
  *ngIf="isVisible && isSmallDevice"
  (click)="closeOnSmallDevice()"
  data-testid="menu-overlay"
></div>
